export default (callback, defaultValue = null) => {
  try {
    return callback();
  } catch (error) {
    return typeof defaultValue === 'function' ? defaultValue() : defaultValue;
  }
}
